export default "__VITE_ASSET__37qGsZBl__"